import styled from 'styled-components';
import { COLOR_RED } from '../../../assets/styles/colors';

export default styled.div`
  .is-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .img-wrap {
      margin-bottom: 15px;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      svg {
        width: 100%;
        height: 60px;
      }
    }
  }
  .is-error {
    padding-top: 15px;
    text-align: center;
  }
  .top-text-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    h2,
    p {
      max-width: 366px;
    }
    p {
      padding-top: 16px;
    }
  }
  .sms-input-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    max-width: 600px;
    width: 100%;
    margin: 0 auto;
    .sms-code {
      padding: 48px 0 24px 0;
      width: 100%;
      justify-content: center;
      display: flex !important;
      gap: 16px;
      @media (max-width: 350px) {
        gap: 8px;
      }
      &.bad-sms {
        input {
          border: 1px solid ${COLOR_RED};
        }
      }
      input {
        height: 50px;
        font-size: 18px;
        width: 80px;
        border: 1px solid rgba(63, 61, 86, 0.4);
        border-radius: 12px;
        text-align: center;
        -webkit-appearance: none;
        -moz-appearance: textfield;
        &::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        &:focus {
          border: 1px solid #3f3d56;
        }
        &:focus,
        &:active {
          outline: none;
        }
      }
    }
    button {
      margin-top: 20px;
      width: 100%;
    }
  }
  .bottom-resend-wrap {
    padding-top: 20px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    text-align: center;
    align-items: center;
    max-width: 600px;
    width: 100%;
    button {
      margin-left: 4px;
    }
  }
`;
